import { InputControls } from "./InputControls";

export const columnDefinitions = {
    coordinates: { type: 'string', inputControl: InputControls.NONE },
    name: { type: 'string', inputControl: InputControls.DROPDOWN }, 
    alternateNames: { type: 'string', inputControl: InputControls.DROPDOWN },
    type: { type: 'string', inputControl: InputControls.DROPDOWN },
    constructor: { type: 'string', inputControl: InputControls.DROPDOWN },
    constructionSite: { type: 'string', inputControl: InputControls.DROPDOWN },
    numberOfCannons:  { type: 'number', inputControl: InputControls.INTERVAL },
    numberOfSoldiers: { type: 'number', inputControl: InputControls.INTERVAL },
    numberOfSailors: { type: 'number', inputControl: InputControls.INTERVAL },
    crewTotal: { type: 'number', inputControl: InputControls.INTERVAL },
    reference: { type: 'string', inputControl: InputControls.NONE },
    comments: { type: 'string', inputControl: InputControls.NONE },
    navalBattles: { type: 'string', inputControl: InputControls.DROPDOWN },
    launchDate: { type: 'number', inputControl: InputControls.INTERVAL },
    displacement: { type: 'number', inputControl: InputControls.INTERVAL },
    numberOfSeaDays:  { type: 'number', inputControl: InputControls.INTERVAL },
    fates: { type: 'string', inputControl: InputControls.DROPDOWN },
    suspension: { type: 'number', inputControl: InputControls.INTERVAL },
    length:  { type: 'number', inputControl: InputControls.INTERVAL },
    width:  { type: 'number', inputControl: InputControls.INTERVAL },
    woodType: { type: 'string', inputControl: InputControls.DROPDOWN },
    status: { type: 'string', inputControl: InputControls.DROPDOWN },
    id: { type: 'number', inputControl: InputControls.NONE },
}
